import React from "react";
import { Transition } from "react-transition-group";

import "./TagWriter.scss";
import I18n from "I18n";
import { loadImage } from "Utils";
import { HTTP, PRODUCTS as PRODUCTS_GENERIC } from "Constants";

class TagWriter extends React.Component {
  IMAGE_CROP_RATIO = 1.25;

  state = {
    isLoading: false,
    showScanResult: false,
    scanResult: false,
    showHelpModal: false,
  };

  massageScanResult(response) {
    const result = response.result;
    if (result > 0) {
      const product = this.lookupProduct(result);

      if (product.isCounterfeit) {
        return {
          title: I18n.scan.result.nonAuthentic.title,
          titleStyle: "danger",
          body: I18n.scan.result.nonAuthentic.description,
        };
      } else {
        return {
          title: I18n.scan.result.authentic.title,
          titleStyle: "success",
          body: I18n.scan.result.authentic.description,
          product: product,
        };
      }
    }

    if (result === 0) {
      return {
        title: I18n.scan.result.nonAuthentic.title,
        titleStyle: "danger",
        body: I18n.scan.result.nonAuthentic.description,
      };
    }

    return {
      title: I18n.errors.scanFailed,
      titleStyle: "warning",
      body: I18n.errors[result] || I18n.errors.imageProcessingGeneric,
    };
  }

  closeResultDrawer = () => {
    if (this.state.showScanResult) {
      this.setState({ showScanResult: false });
    }
  };

  lookupProduct(serialNumber) {
    const product = this.props.products
      ? this.props.products[serialNumber]
      : PRODUCTS_GENERIC[serialNumber];
    if (product) {
      return {
        title: product.title,
        subtitle: product.subtitle,
        imageSrc: product.image,
        footnote: `Serial #: ${product.serialNumber}`,
        productUrl: product.link,
        isCounterfeit: false || product.isCounterfeit,
        externalLink: product.externalLink,
      };
    } else {
      return {
        title: "Product not found",
        footnote: `Serial #: ${serialNumber}`,
      };
    }
  }

  onChange = async (e) => {
    this.setState({
      isLoading: true,
      scanResult: false,
      showScanResult: false,
    });
    const algorithm = this.props.algorithm;
    const formData = new FormData();
    const image = e.target.files[0];
    const { imageBlob, exif } = await loadImage(image, {
      aspectRatio: this.IMAGE_CROP_RATIO,
    });

    formData.append("image", imageBlob);
    formData.append("algorithm", algorithm.toString());
    if (this.props.url) {
      formData.append("source", this.props.url);
    }
    fetch(`${HTTP.BASE_URL}/v1/scan`, {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((response) => {
        const massagedResults = this.massageScanResult(response);

        this.setState({
          showScanResult: true,
          scanResult: massagedResults,
        });
      })
      .catch(() => {
        this.setState({
          showScanResult: true,
          scanResult: this.massageScanResult({ result: -1000 }), // cannot reach API
        });
      })
      .finally(() => {
        setTimeout(() => this.setState({ isLoading: false }), 1000);
      });
  };

  render() {
    let { isLoading, scanResult, showScanResult, showHelpModal } = this.state;
    const scanButtonText = isLoading ? "" : I18n.scan.scanButton;
    const loadingClass = isLoading ? "loading" : "";
    const showFullDrawerClass = "full";

    return (
      <React.Fragment>
        <div
          className="scan-container tag-writer"
          onClick={this.closeResultDrawer}
        >
          <div className="instructions-container">
            <span className="title">
              <b>{I18n.scan.instructions.title}</b>
            </span>
            <span className="step">{I18n.scan.instructions.step1}</span>
            <span className="step">{I18n.scan.instructions.step2}</span>
            <span className="step">{I18n.scan.instructions.step3}</span>
          </div>
          <div className="scan-button-container">
            <label
              htmlFor="file-upload"
              className={`scan-button ${loadingClass}`}
            >
              {scanButtonText}
            </label>
            <input
              type="file"
              accept="image/*"
              capture="environment"
              id="file-upload"
              onChange={this.onChange}
            />
          </div>
          <h5
            onClick={() => this.setState({ showHelpModal: true })}
            className="help-link"
          >
            Tutorial (video)
          </h5>
        </div>

        <div
          className={`help-container ${showHelpModal ? "show" : ""}`}
          onClick={() => this.setState({ showHelpModal: false })}
        >
          <div className="help-modal">
            <div className="instructions-gif">
              <div
                className="close-button"
                onClick={() => this.setState({ showHelpModal: false })}
              >
                x
              </div>
              <img
                src={`${process.env.PUBLIC_URL}/photo-instructions.gif`}
              ></img>
            </div>
          </div>
        </div>

        <Transition in={showScanResult} timeout={1000}>
          {(transitionState) => (
            <div
              className={`result-container tag-writer ${transitionState} ${showFullDrawerClass}`}
            >
              {/* <div className='result-card-title'>Write to tag</div> */}
              {/* <div className={`results-card `}>
                <div className={`header ${scanResult.titleStyle}`}><span>{"Hello"}</span></div>
                <div className="body">{"do we need this?"}</div>
              </div> */}
              <h3>Write to tag</h3>
              <div className="result-body">
                <React.Fragment>
                  <label className="input-label">Name</label>
                  <input className="input"></input>
                  <label className="input-label">Authentication method</label>
                  <input className="input"></input>
                  <label className="input-label">Brand</label>
                  <input className="input"></input>
                  <label className="input-label">Style</label>
                  <input className="input"></input>
                  <label className="input-label">Serial number</label>
                  <input className="input"></input>
                  {/* <h2 className='title'>{"this is the title"}</h2>
                  <h3 className='subtitle'>{"this is the subtitle"}</h3>
                  <span className='footnote'>{"Footnote"}</span> */}
                  <button
                    onClick={() => {
                      this.setState({ showScanResult: false });
                    }}
                    className="submit-button"
                  >
                    Submit
                  </button>
                </React.Fragment>
              </div>
            </div>
          )}
        </Transition>
      </React.Fragment>
    );
  }
}

export default TagWriter;
